module.exports = __webpack_public_path__ + "static/media/ASAMBLEA_ALIM_2021_PRESENTACIONES.9efef19a.zip";